import * as TncActions from "../actionTypes/tncActionTypes";
import { IErrorResponseType } from "../../constants/commonTypes";
import { TncState } from "../reducers/tncReducer";


export function submitTncConsent(request: object): TncActions.SubmitTncConsentAction {
  return {
    type: TncActions.SUBMIT_TNC_CONSENT,
    request
  };
}

export function submitTncConsentRequest(): TncActions.SubmitTncConsentRequestAction {
  return {
    type: TncActions.SUBMIT_TNC_CONSENT_REQUEST
  }
}

export function submitTncConsentSuccess(response: TncState): TncActions.SubmitTncConsentSuccessAction {
  return {
    type: TncActions.SUBMIT_TNC_CONSENT_SUCCESS,
    response
  }
}

export function submitTncConsentFailure(error: Error | string | IErrorResponseType): TncActions.SubmitTncConsentFailureAction {
  return {
    type: TncActions.SUBMIT_TNC_CONSENT_FAILURE,
    error
  }
}

export function getTnc(): TncActions.GetTncAction {
  return {
    type: TncActions.GET_TNC
  };
}

export function getTncRequest(): TncActions.GetTncRequestAction {
  return {
    type: TncActions.GET_TNC_REQUEST
  }
}

export function getTncSuccess(response: TncState): TncActions.GetTncSuccessAction {
  return {
    type: TncActions.GET_TNC_SUCCESS,
    response
  }
}

export function getTncFailure(error: Error | string | IErrorResponseType): TncActions.GetTncFailureAction {
  return {
    type: TncActions.GET_TNC_FAILURE,
    error
  }
}
